import { Core } from "Components/core";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI from "photoswipe/dist/photoswipe-ui-default";
// import PhotoSwipe from "photoswipe/dist/photoswipe.esm";

const galleryPswp = document.querySelector(".pswp");
const ITEM_CLASS = "gallery__item";

export class Gallery extends Core {
  constructor(domElem) {
    super(domElem, Gallery.className);
    this.update();
    domElem.addEventListener("click", this._onClick.bind(this));
  }

  update() {
    this._items = this.getElemsNode("item");
    this._gallery = this._buildGallery();
  }

  _initPhotoSwipe(items, index) {
    console.log("_initPhotoSwipe", items, index);
    console.log("_initPhotoSwipe", this.params);
    var gallery = new PhotoSwipe(
      galleryPswp,
      PhotoSwipeUI,
      items,
      Object.assign(
        {
          index: index,
        },
        this.params.options
      )
    );
    items.forEach(function (item) {
      if (item.responsiveImg) {
        var screenWidth,
          useLargeImages = false,
          imageSrcWillChange;
        gallery.listen("beforeResize", function () {
          screenWidth = window.innerWidth;

          if (useLargeImages && screenWidth < 768) {
            useLargeImages = false;
            imageSrcWillChange = true;
          } else if (!useLargeImages && screenWidth >= 768) {
            useLargeImages = true;
            imageSrcWillChange = true;
          }

          if (imageSrcWillChange) {
            gallery.invalidateCurrItems();
          }

          imageSrcWillChange = false;
        });
        gallery.listen("gettingData", function (index, item) {
          if (useLargeImages) {
            item.src = item.originalImage.src;
            item.w = item.originalImage.w;
            item.h = item.originalImage.h;
          } else {
            item.src = item.mobileImage.src;
            item.w = item.mobileImage.w;
            item.h = item.mobileImage.h;
          }
        });
      }
    });
    gallery.init();
    gallery.listen("close", function () {
      if (this.currItem.type === "youtube") {
        var div = document.querySelector(".video-wrapper");
        var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
        iframe.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      } else if (this.currItem.type === "rutube") {
        var div = document.querySelector(".video-wrapper");
        var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
        iframe.postMessage('{"type":"player:pause", "data":{} }', "*");
      }
    });
  }

  _buildGallery() {
    return Array.prototype.map.call(this._items, function (item) {
      var data = JSON.parse(item.getAttribute("data-js") || "{}")[ITEM_CLASS];

      if (data.type === "video") {
        data.html = [
          '<div class="pswp__video">',
          '<video class="video video_responsive_width" controls="">',
          '<source class="video__source" src="'.concat(
            data.src,
            '" type="video/mp4">'
          ),
          "</video>",
          "</div>",
        ].join("");
        delete data.src;
      } else if (data.type === "youtube") {
        data.html = [
          '\n          <div class="video-wrapper">\n            <iframe class="pswp__video"\n              src="https://www.youtube.com/embed/'.concat(
            data.src,
            '?enablejsapi=1" \n              frameborder="0" \n              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n           </iframe>\n          </div>'
          ),
        ].join("");
        delete data.src;
      } else if (data.type === "rutube") {
        data.html = [
          '\n          <div class="video-wrapper">\n            <iframe class="pswp__video"\n              src="https://rutube.ru/play/embed/'.concat(
            data.src,
            '?enablejsapi=1" \n              frameborder="0" \n              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n           </iframe>\n          </div>'
          ),
        ].join("");
        delete data.src;
      }

      return data;
    });
  }

  _onClick(e) {
    var target = e.target;
    var item = null,
      closest = target.closest(".".concat(ITEM_CLASS));
    if (target.classList.contains(ITEM_CLASS)) item = target;
    else if (closest) item = closest;
    item &&
      this._initPhotoSwipe(
        this._gallery,
        Array.from(this._items).indexOf(item)
      );
  }

  static className = "gallery";
  static instances = {};

  static init() {
    document
      .querySelectorAll(".".concat(Gallery.className))
      .forEach(function (el) {
        return new Gallery(el);
      });
  }
}
